import { isDate, replaceIf, showDateOnly } from "../../Common/Utility";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
function columnBuilder() {
  const columns = [
    {
      field: "studentName",
      headerName: "Schüler/in",
      width: 290,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "regionName",
      headerName: "Region",
      width: 200,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value === "0" ? "" : params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value === "0" ? "" : params.value;
      },
    },
    {
      field: "branchName",
      headerName: "Abrechnungstelle",
      width: 230,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value === "0" ? "" : params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value === "0" ? "" : params.value;
      },
    },

    {
      field: "pdfDate",
      headerName: "PDF-Datum",
      width: 150,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return isDate(params.value) ? showDateOnly(params.value) : "";
      },
    },

    {
      field: "period",
      headerName: "Zeitraum",
      type: "text",
      editable: false,
      width: 200,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return replaceIf(params.value, "-", "--");
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return replaceIf(params.value, "-", "--");
      },
    },
    {
      field: "pdfFileName",
      headerName: "PDF-Datei",
      type: "text",
      editable: false,
      width: 370,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return (
          <div>
            <span style={{ color: "#d32f2f" }}>
              <PdfIcon variant="contained" />
            </span>
            &nbsp;&nbsp;
            <a href="##">{params.value}</a>
          </div>
        );
      },
    },
  ];
  return columns;
}
export default columnBuilder;
